import { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const addToCart = useCallback((mushroom) => {
    setCart(prev => {
      const existing = prev.find(item => item.mushroom.id === mushroom.id);
      if (existing) {
        return prev.map(item =>
          item.mushroom.id === mushroom.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { mushroom, quantity: 1 }];
    });
    setIsCartOpen(true);
  }, []);

  const removeFromCart = useCallback((id) => {
    setCart(prev => prev.filter(item => item.mushroom.id !== id));
  }, []);

  const updateQuantity = useCallback((id, qty) => {
    if (qty < 1) return;
    setCart(prev =>
      prev.map(item =>
        item.mushroom.id === id ? { ...item, quantity: qty } : item
      )
    );
  }, []);

  const clearCart = useCallback(() => setCart([]), []);

  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  const cartTotal = cart.reduce((sum, item) => sum + item.mushroom.price * item.quantity, 0);

  const openWhatsApp = useCallback(() => {
    if (cart.length === 0) return;
    const lines = cart.map(
      item => `  - ${item.mushroom.name} (${item.mushroom.uom || "250g"}) Rs.${item.mushroom.price} x${item.quantity} = Rs.${item.mushroom.price * item.quantity}`
    );
    const msg = `Hello PIIKK Agro Farm Fresh Mushrooms! I'd like to place an order:\n\n${lines.join('\n')}\n\nTotal: Rs.${cartTotal}\n\nPlease confirm availability and delivery details. Thank you!`;
    const url = `https://wa.me/916362516143?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  }, [cart, cartTotal]);

  return (
    <CartContext.Provider value={{
      cart, cartCount, cartTotal,
      addToCart, removeFromCart, updateQuantity, clearCart,
      isCartOpen, setIsCartOpen, openWhatsApp
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
